import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import type { PolymorphicRef } from '@sds-system/types';
import type { ElementType } from 'react';
import { forwardRef } from 'react';
import { StyledDropdownContent, StyledDropdownItem } from './Dropdown.styled';
import type { DropdownComponent, DropdownProps } from './Dropdown.types';

export const Dropdown: DropdownComponent = forwardRef(
  <C extends ElementType = 'div'>(
    { size = 'M', align, children, options, textAlign, styledComponents }: DropdownProps<C>,
    ref: PolymorphicRef<C>,
  ) => {
    return (
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild ref={ref}>
          {children}
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>
          <StyledDropdownContent align={align} textAlign={textAlign} {...styledComponents?.content}>
            {options.map((item, index) => (
              <StyledDropdownItem
                // biome-ignore lint/suspicious/noArrayIndexKey: unique값 없음
                key={index}
                onClick={item.onClick}
                {...styledComponents?.item}
                size={size}
              >
                {item.label}
              </StyledDropdownItem>
            ))}
          </StyledDropdownContent>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    );
  },
);
